import React from 'react';
import { useDisclose } from '../../../../Modal/Hooks/useDisclose';
import { DoctorSickLeavesQuery } from '../../../../../graphql/graphql';
import { QueryDataItem } from '../../../../../Interfaces/QueryDataItem';
import CSSZSickLeaveCertificateConfirmationOfDurationModal from '../../../../CSSZSickLeaveCertificate/Components/CSSZSickLeaveCertificateConfirmationOfDuration/CSSZSickLeaveCertificateConfirmationOfDurationModal';
import CSSZSickLeaveMoneyTicketDetailItem, {
	MoneyTicketType,
} from '../../../../CSSZSickLeaveCertificate/Components/CSSZSickLeaveCertificateDetail/CSSZSickLeaveMoneyTicketDetailItem';
import { transformDocumentToSickLeaveCertificate } from '../../../../CSSZSickLeaveCertificate/Helpers/transformDocumentToSickLeaveCertificate.helper';
import styles from './ManagerSickLeaveMoneyTicketConfirmationCell.module.scss';

type Row = QueryDataItem<DoctorSickLeavesQuery['documents']>;

interface Props {
	row: Row;
}

const ManagerSickLeaveMoneyTicketConfirmationCell: React.FC<Props> = ({
	row,
}) => {
	const moneyTicket = row.items?.find(i => i?.type === 'sickLeaveMoneyTicket');
	const { isOpen, onOpen, onClose } = useDisclose();

	if (!moneyTicket) {
		return null;
	}

	const certificate = transformDocumentToSickLeaveCertificate(row);
	const patientId = row.user?.id;
	const canOpenModal = Boolean(certificate && patientId);

	const content = (
		<CSSZSickLeaveMoneyTicketDetailItem
			item={moneyTicket}
			type={MoneyTicketType.SHORT}
		/>
	);

	if (!canOpenModal) {
		return content;
	}

	const handleClick = (e: React.MouseEvent) => {
		e.stopPropagation();
		onOpen();
	};

	return (
		<>
			<div className={styles.clickable} onClick={handleClick}>
				{content}
			</div>
			{isOpen && certificate && patientId && (
				<CSSZSickLeaveCertificateConfirmationOfDurationModal
					isOpen
					item={certificate}
					patientId={patientId}
					onClose={onClose}
					onCreate={onClose}
				/>
			)}
		</>
	);
};

export default ManagerSickLeaveMoneyTicketConfirmationCell;
